import Clarity from './clarity';
import GA from './ga';
import PostHog from './posthog';
import { AnalyticsConfig, AnalyticsProvider } from './types';

const providers: AnalyticsProvider[] = [ Clarity, GA, PostHog ];

const Analytics = {
    init: (config: AnalyticsConfig) => providers.forEach(p => p.init(config)),
    event: (name: string, data?: Record<string, unknown>) =>
        providers.forEach(p => p.event?.(name, data))
};

export default Analytics;
